<template>
  <div v-if="adminView">
    <v-card-title>
      <h3 class="headline my-0">{{ $t('Datos identificativos (Aplifisa)') }}</h3>
    </v-card-title>
    <v-divider light></v-divider>
    <v-card-text>
      <v-layout wrap>
        <v-flex xs6 pr-3>
          <v-text-field
            v-model="formData.CODEMPRE"
            :disabled="disabled"
            :label="'Código de empresa'"
            box
            v-if="adminView"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field
            v-model="formData.CODTRAB"
            :disabled="disabled"
            :label="'Código de trabajador'"
            box
            v-if="adminView"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-card-text>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    adminView: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default() {
        return {
          fullname: null,
          nif: null,
          num_ss: null,
          birthdate: null,
          address: null,
          city: null,
          province: null,
          cp: null,
          nationality: null,
          phone: null,
          email: null,
          F_ALTA: null,
          F_BAJA: null,
          F_ANTIG: null,

          CODEMPRE: null,
          CODTRAB: null,
          OBSERVACIONES: null,
          DISCAPACIDAD: null,
          IMPUESTO: null,
          TIPO_IRPF: null,
          CLAVE_IRPF: null,
          PUESTO: null,
          F_CONTR: null,
          F_HASTA_CONTR: null,
          HORAS_DIA: null,
          HORAS_SEM: null,
          REGIMEN: null,
          BRUTO: null,
          TITUL_ACADEMICA: null,
          NUM_AFILIACION_SUSTITUIDO: null,
          CAUSA_SUSTITUCION: null,
        };
      },
    },
  },
  data() {
    return {
      camposDatosContrato: [
        {
          fieldName: 'F_ALTA',
          label: 'Fecha de Alta',
          pr3: true,
        },
        {
          fieldName: 'F_BAJA',
          label: 'Fecha de Baja',
          pr3: true,
        },
        {
          fieldName: 'F_ANTIG',
          label: 'Antigüedad',
          pr3: false,
        },
        {
          fieldName: 'OBSERVACIONES',
          label: 'Observaciones',
          pr3: true,
        },
        {
          fieldName: 'DISCAPACIDAD',
          label: 'Discapacidad',
          pr3: true,
        },

        {
          fieldName: 'PUESTO',
          label: 'Puesto',
          pr3: false,
        },
        {
          fieldName: 'F_CONTR',
          label: 'Fecha Contratación',
          pr3: true,
        },
        {
          fieldName: 'F_HASTA_CONTR',
          label: 'Expiración de contrato',
          pr3: true,
        },
        {
          fieldName: 'HORAS_DIA',
          label: 'Horas al Día',
          pr3: false,
        },
        {
          fieldName: 'HORAS_SEM',
          label: 'Horas Semanales',
          pr3: true,
        },
        {
          fieldName: 'REGIMEN',
          label: 'Regimen',
          pr3: true,
        },
        {
          fieldName: 'BRUTO',
          label: 'Bruto',
          pr3: false,
        },
        {
          fieldName: 'TITUL_ACADEMICA',
          label: 'Titulación Academica',
          pr3: true,
        },
        {
          fieldName: 'IMPUESTO',
          label: 'Impuesto',
          admin: true,
          pr3: true,
        },
        {
          fieldName: 'TIPO_IRPF',
          label: 'Tipo IRPF',
          admin: true,
          pr3: false,
        },
        {
          fieldName: 'CLAVE_IRPF',
          label: 'Clave IRPF',
          admin: true,
          pr3: true,
        },
        // {
        //   fieldName: 'NUM_AFILIACION_SUSTITUIDO',
        //   label: 'Número Afiliacion Sustituido'
        // },
        // {
        //   fieldName: 'CAUSA_SUSTITUCION',
        //   label: 'Causa Sustitucion'
        // },
      ],
      selectedWorkerProperties: {
        CODEMPRE: '1', // admin
        CODTRAB: '49', // admin

        // En datos trabajador
        NIF: '20478772D',
        NUM_AFILIACION: '121011826503',
        APELLIDO1: 'GARCIA ',
        APELLIDO2: 'BARBA',
        NOMBRE: 'MARIA ISABEL',
        FEC_NACI: '1985-03-06',
        TELEF1: '',
        TELEF2: '',
        EMAIL: '',
        address: 'CL. CELTITAN nº 14,',
        fullname: 'GARCIA  BARBA, MARIA ISABEL',
        nationality: 'ESPAÑA',
        province: 'SEVILLA',
        city: 'PEÑAFLOR',
        company_name: 'OPENGES SERVICIOS INTEGRALES DE ASESORAMIENTO',

        // En datos contrato
        F_ALTA: '2021-01-10',
        F_BAJA: null,
        F_ANTIG: '2021-01-10',
        OBSERVACIONES: 'Categoría: Oficial de Primera. \n...',
        DISCAPACIDAD: '0.00',
        IMPUESTO: 'C', // admin
        TIPO_IRPF: '2.00', // admin
        CLAVE_IRPF: 'A', // admin
        PUESTO: 'OFICIAL 1.ª - GRUPO II',
        F_CONTR: '2021-01-10',
        F_HASTA_CONTR: '2021-07-09',
        HORAS_DIA: '8.00',
        HORAS_SEM: '40.00',
        REGIMEN: 'G',
        BRUTO: '8147.34',
        TITUL_ACADEMICA: '',
        NUM_AFILIACION_SUSTITUIDO: '',
        CAUSA_SUSTITUCION: '',
      },
      allWorkerProperties: {
        CODEMPRE: '1',
        CODTRAB: '49',
        CENTRO: '1',
        SUBCENTRO: null,
        NIF: '20478772D',
        NUM_AFILIACION: '121011826503',
        CLASIFICADOR: '',
        TIPONIF: '1',
        APELLIDO1: 'GARCIA ',
        APELLIDO2: 'BARBA',
        NOMBRE: 'MARIA ISABEL',
        FEC_NACI: '1985-03-06',
        EDAD: '35',
        SEXO: '1',
        NACIONALIDAD: '71',
        SIGLA: 'CL',
        VIA: 'CELTITAN',
        NUMERO: '14',
        ESC: '',
        PISO: '',
        PUERTA: '',
        CODPOS: '41470',
        MUNICIPIO: '41074',
        PROVINCIA: '41',
        COD_PAIS: '71',
        TELEF1: '',
        TELEF2: '',
        EMAIL: '',
        NIF_REP: '',
        APENOM_REP: '',
        CALIDAD: '',
        FEC_PODER: null,
        OTORGANTE: '',
        F_ALTA: '2021-01-10',
        F_BAJA: null,
        F_ANTIG: '2021-01-10',
        OBSERVACIONES:
          'Categoría: Oficial de Primera. \nJornada: Completa.\nRetribución: Según Convenio.\nBANCO: ES55 2100 0460 4101 0107 7872.',
        DISCAPACIDAD: '0.00',
        IMPUESTO: 'C',
        TIPO_IRPF: '2.00',
        CLAVE_IRPF: 'A',
        SIT_FAM: '3',
        NIFCONY: '',
        MOVRED: 'N',
        CEUTAMELILLA: 'N',
        REDMOVGEO: 'N',
        PENCONY: '0.00',
        ANUALI: '0.00',
        F_CONVEN: '2019-12-31',
        F_EXTRA: '2021-01-10',
        CONVENIO: '2',
        CATEGORIA: '5',
        NIVEL: '55',
        PUESTO: 'OFICIAL 1.ª - GRUPO II',
        COD_OCUPACION: '4111',
        COD_CONTR_INEM: '146',
        SUBCOD_CONTR: '1',
        COD_CONTR_SS: '402',
        F_CONTR: '2021-01-10',
        F_REG_CONTR: '2021-01-10',
        F_HASTA_CONTR: '2021-07-09',
        FICH_CONTR: '',
        HORAS_DIA: '8.00',
        HORAS_SEM: '40.00',
        DISTRIBUCION: '',
        DUR_PRUE: '0',
        TIPO_DUR_PRUE: 'N',
        PROMO_CRITER: '',
        PROMO_TIEMPO: null,
        PROMO_CATEG: null,
        NUM_PROR: null,
        F_PROR_DESDE: null,
        F_PROR_HASTA: null,
        MES_PROR: null,
        DIAS_PROR: null,
        MES_TOT_PROR: null,
        DIAS_TOT_PROR: null,
        MES_MAX_PROR: null,
        DIAS_MAX_PROR: null,
        FEC_LIM_PROR: null,
        DIAS_INDEM: null,
        UNID_INDEM: '',
        UNID_COMPU: '',
        DIAS_TOPE: null,
        REGIMEN: 'G',
        GRUPO: '5',
        EPIGRAFE: null,
        COBRO: 'M',
        PLURI_CC: '0.00',
        PLURI_CP: '0.00',
        PLURI_AUTOR: '',
        ABONO: '',
        FORMAP: null,
        CCC: '00000000000000000000',
        RET_JUD_MES: null,
        RET_JUD_TOT: null,
        F_PREAVISO: null,
        CAUSA: null,
        OBSERBAJA: '',
        F_FINIQ: null,
        F_NOMORD: null,
        ACUNOMORD: 'S',
        F_NOMEXT: null,
        ACUNOMEXT: 'N',
        F_INDEM: null,
        F_IMPFIN: null,
        FICFINIQ: '',
        ACUINDEM: 'N',
        F_TA2: null,
        F_COMUN: null,
        F_CEREMP: null,
        FICCEREMP: '',
        DIAVAC: '0.00',
        IMP_FINIQ: '0.00',
        F_INDDESDE: null,
        F_INDHASTA: null,
        U_INDEM: '0.00',
        M_INDEM: 'D',
        CONCINDEM: '',
        IMP_INDEM: '0.00',
        L: '1.00',
        M: '1.00',
        X: '1.00',
        J: '1.00',
        V: '1.00',
        S: '0.00',
        D: '0.00',
        TIPO_COT: 'TC',
        BRUTO: '8147.34',
        RENTASIRR: '0.00',
        GASTOSDED: '521.43',
        IMPEXENTO: '0.00',
        PORJORNADA: '100.00',
        LIBROMAT: '',
        IMP_FORMACION: '0.00',
        IMP_FORMACION_DIS: '0.00',
        INDEM_VACAC: '0.00',
        IMP_VACAC: '0.00',
        DIAS_PP_VACAC: '0.00',
        CODCONC_PACTO: '0',
        TIPO_PACTO: '',
        IMPORTE_PACTO: '0.00',
        AJUSTE_PAGAS: 'N',
        COPA_AMERICA: 'N',
        TIPO_CONTRATO_IRPF: 'I',
        F_FIN_PERMISO: null,
        TITUL_ACADEMICA: '',
        COP: '',
        ESTADO_CIVIL: 'S',
        AGR_EVENTUAL: 'S',
        INDEM_IRPF: 'N',
        TIEMPO_PARCIAL: 'N',
        TP_DESCANSO: 'S',
        COT_DESEMPLEO: '',
        OCU_SS: '',
        TIPO_IRPF_MINIMO: '0.00',
        F_ENTREGA_ROPA: null,
        F_ENTREGA_SEGURIDAD: null,
        F_RENUNCIA_RECONOCIMIENTO: null,
        BANCO_SALARIOS: null,
        NOMBRE_PADRE: '',
        NOMBRE_MADRE: '',
        LUGAR_NACIMIENTO: '',
        COD_COLECTIVO: '',
        CONDICION_DISCAPACIDAD: '',
        AGRARIO_EXTRAN: '',
        RLCE: '',
        PACTO_IT: '',
        MUJERSUB: '',
        DESEMP: '',
        INCAP_READ: '',
        TRAB_AUTO: '',
        RENTA_ACT: '',
        M24: '',
        EXCLUSION: '',
        MUJER_REINCORPORADA: '',
        CC_MUTUA: '',
        MOTIVO_RED_JORNADA: '',
        COT_FOGASA: 'N',
        AGRARIO_ADMINISTRADOR: 'N',
        HORAS_FORMACION: '0.00',
        CNO: '',
        MENOR30_AUTONOMO: '',
        MOSTRAR_INF: 'S',
        DED_400: 'S',
        EXCLUSION_DESEMPLEO: '',
        NUM_AFILIACION_SUSTITUIDO: '',
        CAUSA_SUSTITUCION: '',
        COTIZACION_AGRARIO: '',
        VIVIENDA_HABITUAL: '',
        F_ANTIG_REAL: '2021-01-10',
        VINCULO_FAMILIAR: '',
        EXCEDENTE_SECTOR_INDUSTRIAL: '',
        TIPO_CONTRATO_540: '',
        VAC_PENDIENTES_EXTRAS: '',
        COLECTIVO_TRABAJADOR: '',
        CAUSA_DESEM_CERT: '',
        CODIGO_REG_CONTRATO: '',
        APLICA_BASE_MAYO: '',
        AGRARIO_FOM_EMP: 'N',
        FORMACION_ESCUELATALLER: 'N',
        FORMACION_NOBONIF2010: 'N',
        BONIFICAR100: 'N',
        INACTIVIDAD: '',
        RENTASIRR2: '0.00',
        CODIGO_COT_MAR: '00',
        CONDICION_DESEMPLEADO: '',
        IBAN: '',
        ID_EXTERNO_1: '',
        ID_EXTERNO_2: '',
        ID_EXTERNO_3: '',
        SITUACION_ADICIONAL: '',
        HORARIO_TURNO: null,
        HORARIO_PERSONALIZADO: 'N',
        TIPO_RELACION_LABORAL: '',
        BRUTO_MANUAL: '',
        BRUTO_MANUAL_IMPORTE: '0.00',
        SEMANA_SEGUN_CONVENIO: 'N',
        PROGRAMA_FORMACION: 'N',
        TIPO_INDEMNIZACION: '',
        SINEXTRA_DIC: '',
        CUENTA_CONTA: '',
        PROLON: 'N',
        INDEM_COTIZ: 'N',
        COTIZ_SOLIDARIDAD: 'N',
        HOGAR_ING_TRAB: 'N',
        BIC: '',
        TIPO_RED_JORNADA: '',
        PORJORNADA_INICIAL: null,
        DOC3W_LOGIN: '',
        GARANTIA_JUVENIL: '',
        SUBCLAVE_IRPF: '',
        FECHA_REDMOVGEO: null,
        PERDIDA_BENEF: '',
        MODO_BONIF_FORMACION: '',
        PORC_SALARIOS: '0.00',
        EXCLUSION_SOCIAL: '',
        PLURI_DESEMPLEO: '0.00',
        PLURI_FP: '0.00',
        PLURI_FOGASA: '0.00',
        HORAS_ANUALES: null,
        CONTA_PROYECTO: '',
        RELEVO: 'N',
        BASE_JUBILADO: '0.00',
        TRABAJO_CONCENTRADO: 'N',
        MODO_ALTA: 'IMP',
        COEF_REDUC_EDAD_JUB: 'N',
        COD_MIGESTIONLABORAL: '',
        PDF_PASS: '',
        INACTIVIDAD_R_INICIO: null,
        INACTIVIDAD_R_FINAL: null,
        TIPO_EMBARCACION: '',
        ID_EMBARCACION: '',
        FOTO: '',
        CLAUSULAS: '',
        address: 'CL. CELTITAN nº 14,',
        fullname: 'GARCIA  BARBA, MARIA ISABEL',
        nationality: 'ESPAÑA',
        province: 'SEVILLA',
        city: 'PEÑAFLOR',
        company_name: 'OPENGES SERVICIOS INTEGRALES DE ASESORAMIENTO',
      },
    };
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {},
  methods: {},
  watch: {},
};
</script>

<style lang="scss"></style>
